<script lang="ts">
  import { t } from "@/libs/i18n"
  import { ICON, Icon } from "@/libs/ui/Icon"
  import type { HTMLButtonAttributes } from "svelte/elements"
  import preview from "./img/preview.png"

  let props: HTMLButtonAttributes = $props()
</script>

<button
  {...props}
  class={`${props.class ?? ""} top-0 flex w-full items-center rounded-2xl bg-[#181818] p-1`}
  class:tutorial-banner={/* anchor for external customization */ true}
>
  <img
    class="left-0 h-[5.375rem] w-[5.375rem]"
    src={preview}
    alt="tutorial"
    class:preview={/* anchor for external customization */ true}
  />
  <section
    class="flex w-full items-center p-4"
    class:section={/* anchor for external customization */ true}
  >
    <p class="text pr-2">{$t.tutorial.how_to_take_a_photo}</p>
    <div
      class="ml-auto flex h-[1.75rem] w-[2.5rem] items-center justify-center rounded-[1.25rem] bg-white"
    >
      <Icon class="icon text-black" type={ICON.ARROW_LEFT} />
    </div>
  </section>
</button>
